var modules_192c04a7 = {"container":"_mx1swy","publickInfo":"_1nuh3k9","icon":"_13u88ux","visible":"_1cyb0pz"};
import "../../../assets/CBGnxr2A.css";

export { modules_192c04a7 as default };
//# sourceMappingURL=Copyrights.module.less.js.map
